import type { ShortVideo, ShortVideoChannel } from '@services/firebase/short-videos'
import { ShortVideoCard } from '@features/short-videos/catalog/ShortVideoCard'

type ShortVideoCardCollectionProps = {
  readonly cellClassName: string
  readonly channels: ShortVideoChannel[]
  readonly currentVideoId?: string
  readonly gridClassName: string
  readonly locale: string
  readonly onSelect: (video: ShortVideo) => void
  readonly videos: readonly ShortVideo[]
}

/**
 * Shared grid mapping for catalog, topic, and recommendation video cards.
 * Layout classes stay screen-owned while card sizing and interaction remain identical.
 */
export function ShortVideoCardCollection({
  cellClassName,
  channels,
  currentVideoId,
  gridClassName,
  locale,
  onSelect,
  videos,
}: ShortVideoCardCollectionProps) {
  return (
    <div className={gridClassName}>
      {videos.map((video) => (
        <div className={`${cellClassName} shortVideoCardGridCell`} key={video.id}>
          <ShortVideoCard
            channels={channels}
            currentPlaying={video.id === currentVideoId}
            locale={locale}
            onClick={() => {
              onSelect(video)
            }}
            video={video}
          />
        </div>
      ))}
    </div>
  )
}
